import React from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { CircularProgress, Box } from '@material-ui/core';
import EnrollmentManager from '../../components/EmailPlatform/EnrollmentManager';
import { withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';

const GET_SEQUENCE_WITH_ENROLLMENTS = gql`
  query GetSequenceEnrollments($sequenceId: ID!, $sequenceIdInt: Int!) {
    emailSequence(id: $sequenceId) {
      id
      name
      description
      active
      steps {
        id
        position
      }
    }
    sequenceEnrollments(sequenceId: $sequenceIdInt) {
      id
      currentStep
      status
      enrolledAt
      completedAt
      user {
        id
        name
        email
      }
    }
  }
`;

const PAUSE_ENROLLMENT = gql`
  mutation PauseEnrollment($id: ID!) {
    pause_enrollment(id: $id) {
      enrollment {
        id
        status
      }
      errors
    }
  }
`;

const RESUME_ENROLLMENT = gql`
  mutation ResumeEnrollment($id: ID!) {
    resume_enrollment(id: $id) {
      enrollment {
        id
        status
      }
      errors
    }
  }
`;

const REMOVE_ENROLLMENT = gql`
  mutation RemoveEnrollment($id: ID!) {
    remove_enrollment(id: $id) {
      success
      errors
    }
  }
`;

class EnrollmentManagerContainer extends React.Component {
  handlePause = (pauseEnrollment, refetch) => (enrollmentId) => {
    pauseEnrollment({
      variables: { id: enrollmentId },
    })
      .then(({ data }) => {
        if (data.pause_enrollment.errors && data.pause_enrollment.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.pause_enrollment.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar('Enrollment paused successfully', { variant: 'success' });
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  handleResume = (resumeEnrollment, refetch) => (enrollmentId) => {
    resumeEnrollment({
      variables: { id: enrollmentId },
    })
      .then(({ data }) => {
        if (data.resume_enrollment.errors && data.resume_enrollment.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.resume_enrollment.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar('Enrollment resumed successfully', { variant: 'success' });
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  handleRemove = (removeEnrollment, refetch) => (enrollmentId) => {
    removeEnrollment({
      variables: { id: enrollmentId },
    })
      .then(({ data }) => {
        if (data.remove_enrollment.errors && data.remove_enrollment.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.remove_enrollment.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar('User removed from sequence successfully', { variant: 'success' });
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  render() {
    const sequenceId = this.props.match.params.id;

    return (
      <Query query={GET_SEQUENCE_WITH_ENROLLMENTS} variables={{ sequenceId, sequenceIdInt: parseInt(sequenceId) }}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
              </Box>
            );
          }

          if (error) {
            return <div>Error loading enrollments: {error.message}</div>;
          }

          // Map steps to emailSequenceSteps for component compatibility
          const sequenceWithSteps = data.emailSequence ? {
            ...data.emailSequence,
            emailSequenceSteps: data.emailSequence.steps,
          } : null;

          return (
            <Mutation mutation={PAUSE_ENROLLMENT}>
              {(pauseEnrollment) => (
                <Mutation mutation={RESUME_ENROLLMENT}>
                  {(resumeEnrollment) => (
                    <Mutation mutation={REMOVE_ENROLLMENT}>
                      {(removeEnrollment) => (
                        <EnrollmentManager
                          sequence={sequenceWithSteps}
                          enrollments={data.sequenceEnrollments || []}
                          onPause={this.handlePause(pauseEnrollment, refetch)}
                          onResume={this.handleResume(resumeEnrollment, refetch)}
                          onRemove={this.handleRemove(removeEnrollment, refetch)}
                        />
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(withSnackbar(EnrollmentManagerContainer));

